module.exports = __webpack_public_path__ + "img/slide2.52bdfa62.png";